import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Bez nabiału',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Pikantne',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Wegańskie',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Bez glutenu',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Wegetariańskie',
};
